export class TaskVariant {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
